import { useEventCallback } from '@mui/material';
import {
  ContainerPopper,
  FakeDropdownBox,
  useDataGridContext,
  ApproverMultipleSelector,
  type ExtendedGridColumnHeaderProps,
  type GroupedUserDto,
} from '@issuemanager/apps/client/components';
import { ApproverColumnFilter } from '@issuemanager/client/features/issues';
import type { IssueGridFilterModel } from './types';

export function IssueGridApproverFilter(_: ExtendedGridColumnHeaderProps) {
  const context = useDataGridContext();
  const issueApprovers: IssueGridFilterModel['approver'] =
    context.filterModel.approver;
  const actionApprovers: IssueGridFilterModel['actionApprover'] =
    context.filterModel.actionApprover;

  const value: GroupedUserDto[] = (issueApprovers ?? []).concat(
    actionApprovers ?? [],
  );

  const handleChange = useEventCallback((value: GroupedUserDto[]) => {
    const approver = value.filter(
      (v) => v.group === ApproverColumnFilter.ISSUE_APPROVER,
    );
    const actionApprover = value.filter(
      (v) => v.group === ApproverColumnFilter.ACTION_APPROVER,
    );
    context.setFilterModel((prevState) => ({
      ...prevState,
      approver,
      actionApprover,
    }));
  });

  return (
    <ContainerPopper
      renderTarget={(props) => (
        <FakeDropdownBox onClick={props.handleClick}>
          {value.length > 0 ? value.map((c) => c.name).join(', ') : null}
        </FakeDropdownBox>
      )}
      renderChildren={(props) => (
        <ApproverMultipleSelector
          open
          value={value}
          onChange={handleChange}
          onClose={props.handleClose}
          TextFieldProps={{
            autoFocus: true,
          }}
        />
      )}
    />
  );
}
